import type { IconData } from '@stacksjs/iconify-core'

export const horizontalAlignLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 10H4V6h11a1 1 0 0 1 1 1z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M21 18H4v-8h17a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1\"/><path fill=\"currentColor\" d=\"M3 22a1 1 0 0 1-1-.999V3a1 1 0 0 1 2 0v18a1 1 0 0 1-.999 1z\" opacity=\".25\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default horizontalAlignLeft
